import { useMemo } from 'react';
import { cn } from '../../lib/utils';

/**
 * The animated bar waveform used across the voice surfaces.
 *
 * Heights are seeded from the bar index rather than Math.random() so they stay
 * stable across re-renders — a random height per render makes the bars twitch
 * whenever any parent state changes.
 */
const WaveformBars = ({ count = 12, active = true, className, barClassName }) => {
  const heights = useMemo(
    () => Array.from({ length: count }, (_, i) => 30 + ((i * 37) % 65)),
    [count]
  );

  return (
    <div className={cn('flex items-end justify-center gap-1 h-12', className)}>
      {heights.map((height, i) => (
        <div
          key={i}
          className={cn(
            'w-1.5 rounded-full bg-primary transition-all duration-300',
            active ? 'animate-wave' : 'opacity-40',
            barClassName
          )}
          style={{
            height: active ? `${height}%` : '12%',
            animationDelay: `${i * 0.08}s`,
            animationDuration: '0.9s',
          }}
        />
      ))}
    </div>
  );
};

export default WaveformBars;
